document.addEventListener("DOMContentLoaded", function () {
    const backToTopButtons = document.querySelectorAll(".back-to-top");
    const scrollToCollectionElements = document.querySelectorAll(".scroll-to__collection");
    let lastScrollY = window.scrollY;
    if (lastScrollY <= 100) {
        backToTopButtons.forEach(button => button.style.visibility = "hidden");
        scrollToCollectionElements.forEach(element => element.style.visibility = "hidden");
    }
    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        backToTopButtons.forEach(button => {
            if (currentScrollY <= 100) {
                button.style.visibility = "hidden";
            } else if (currentScrollY < lastScrollY) {
                button.style.visibility = "visible";
            } else {
                button.style.visibility = "hidden";
            }
        });

        scrollToCollectionElements.forEach(element => {
            if (currentScrollY <= 100) {
                element.style.visibility = "hidden";
            } else if (currentScrollY < lastScrollY) {
                element.style.visibility = "visible";
            } else {
                element.style.visibility = "hidden";
            }
        });

        lastScrollY = currentScrollY;
    };

    let timeout = null;
    const throttledScroll = () => {
        if (!timeout) {
            timeout = setTimeout(() => {
                handleScroll();
                timeout = null;
            }, 100);
        }
    };
    window.addEventListener("scroll", throttledScroll);
    backToTopButtons.forEach(button => {
        button.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    });
});